import React, { useEffect, useState } from 'react';
import { Button, Card, Layout, notification, Spin } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import './index.scss';
import { useTranslation } from 'react-i18next';
import image from 'shared/images/404.svg';
import { useLocation } from 'react-use';
import API_SERVICE from 'shared/services/api-service';
import Parameters from 'shared/parameters';


export default function StaticPagesView() {
    const { t } = useTranslation();
    const [fetching, setFetching] = useState(false);
    const [content, setContent] = useState(null as any);
    const RouteParams: any = useParams();
    const location: any = useLocation();
    const refreshItem = async () => {
        try {
            setFetching(true);
            if (localStorage.getItem('Pages-ADMIN' + RouteParams['mode'])) {
                setContent(JSON.parse(localStorage.getItem('Pages-ADMIN' + RouteParams['mode']) as string));
                setFetching(false);
            }
            const {
                data: { data },
            } = await API_SERVICE.fetchStaticPageByPath(RouteParams['mode']);
            localStorage.setItem('Pages-ADMIN' + RouteParams['mode'], JSON.stringify(data));
            setContent({
                ...data,
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItem();
    }, [location]);
    if (!content) {
        return <Layout className="__pages-blank">
            <Card className={'static-page-card'}>
                <Spin/>
            </Card>
        </Layout>;
    }
    return (
        <Layout className="__pages-blank">
            <div dangerouslySetInnerHTML={{ __html: content.description }}/>
        </Layout>
    );
}
